module.exports = __webpack_public_path__ + "assets/60f8fc41717d6c4d3957ee98959c3fce.mp4";